import { ReactNode, useCallback, useContext } from 'react';
import { Alarm } from 'types/Organizer';
import { MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { eventFormContext } from './EventFormContext';
import { FormattedMessage } from 'react-intl';
import useStyles from '../EventForm.styles';

type AlarmSelectPureProps = {
  alarm: Alarm;
  alarms: AlarmSelectItemType[];
  disabled: boolean;
  handleAlarmChange: (event: SelectChangeEvent<Alarm>) => void;
};

const AlarmSelectPure = ({
  alarm,
  alarms,
  disabled,
  handleAlarmChange,
}: AlarmSelectPureProps): JSX.Element => {
  const classes = useStyles();

  return (
    <Select
      className={classes.field}
      data-testid="folder-contacts-select"
      disabled={disabled}
      size="small"
      value={alarm}
      onChange={handleAlarmChange}
    >
      {alarms.map((alarmItem) => (
        <MenuItem key={alarmItem.value} value={alarmItem.value}>
          {alarmItem.label}
        </MenuItem>
      ))}
    </Select>
  );
};

export type AlarmSelectItemType = {
  label: ReactNode;
  value: Alarm;
};

const getAlarms = (): AlarmSelectItemType[] => [
  {
    label: <FormattedMessage id="alarm.NO_ALARM" />,
    value: Alarm.NO_ALARM,
  },
  { label: <FormattedMessage id="alarm.ON_TIME" />, value: Alarm.ON_TIME },
  {
    label: <FormattedMessage id="alarm.BEFORE_15_MIN" />,
    value: Alarm.BEFORE_15_MIN,
  },
  {
    label: <FormattedMessage id="alarm.BEFORE_30_MIN" />,
    value: Alarm.BEFORE_30_MIN,
  },
  {
    label: <FormattedMessage id="alarm.BEFORE_60_MIN" />,
    value: Alarm.BEFORE_60_MIN,
  },
];

const AlarmSelect = (): JSX.Element => {
  const { alarm, disabled, setAlarm } = useContext(eventFormContext);

  const handleAlarmChange = useCallback(
    (event: SelectChangeEvent<Alarm>) => {
      const alarmValue: Alarm = event.target.value as Alarm;

      return setAlarm(alarmValue);
    },
    [setAlarm],
  );

  const alarms = getAlarms();

  return (
    <AlarmSelectPure
      alarm={alarm}
      alarms={alarms}
      disabled={disabled}
      handleAlarmChange={handleAlarmChange}
    />
  );
};

export default AlarmSelect;
